import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {
    init: function() {
      gsap.registerPlugin( ScrollTrigger );

      $( '.statistics__card' ).not( '.is-animated' ).each( function( key, component ) {
        let isAnimated = false;
        const tl = gsap.timeline( {
          scrollTrigger: {
            trigger: component,
            start: 'top 95%',
            scrub: 0.5,
            onEnter: ( {progress, direction, isActive} ) => {
              if ( !isAnimated ) {
                numberAnimations( component );
                isAnimated = true;
              }
            },
          },
        } );
      } );

      function numberAnimations( el ) {
        $( el ).find( '.increase-num' ).each( function() {
          const $this = $( this );
          const initialNum = $( this ).text();
          const counter = 0;
          const size = $( this ).text().split( '.' )[1] ? $( this ).text().split( '.' )[1].length : 0;
          $( {Counter: counter} ).animate( {Counter: $this.text().replace( /,/g, '' )}, {
            duration: 1000,
            easing: 'swing',
            step: function() {
              const num = parseFloat( this.Counter ).toFixed( size ).toString().replace( /\B(?=(\d{3})+(?!\d))/g, ',' );
              $this.text( num );
            },
            complete: function() {
              $this.text( initialNum.replace( /\B(?=(\d{3})+(?!\d))/g, ',' ) );
            },
          } );
        } );

        $( el ).find( '.decrease-num' ).each( function() {
          const $this = $( this );
          const counter = 100;
          const initialNum = $( this ).text();
          const size = $( this ).text().split( '.' )[1] ? $( this ).text().split( '.' )[1].length : 0;
          $( {Counter: counter} ).animate( {Counter: $this.text().replace( /,/g, '' )}, {
            duration: 1000,
            easing: 'swing',
            step: function() {
              const num = parseFloat( this.Counter ).toFixed( size ).toString().replace( /\B(?=(\d{3})+(?!\d))/g, ',' );
              $this.text( num );
            },
            complete: function() {
              $this.text( initialNum.replace( /\B(?=(\d{3})+(?!\d))/g, ',' ) );
            },
          } );
        } );
      }
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'statistics', COMPONENT );
} )( app );
